<button [id]="buttonId" [class]="'sb-container sb-status-' + buttonStatus + ' sb-container-' + size"
  matRipple [matRippleAnimation]="{ enterDuration: 400 }" (click)="emitClick()"
  [ngClass]="{ 'sb-status-loading': loading }">
  <div *ngIf="!loading" class="kenjo-font-size-16px">{{ title }}</div>
  <div *ngIf="loading" class="kenjo-font-size-16px">
    <kenjo-loading-spinner></kenjo-loading-spinner>
  </div>
</button>
